import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import DocumentHead from 'legacyComponents/documentHead';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { ThreadCard } from 'legacyComponents/cards/types/thread';

import { RepoSpinner } from 'apps/repository/styles';
import { FourOhFour } from 'apps/fourOhFour';
import { Intro } from 'apps/forum/views/intro';
import { CategoryAppManager } from 'apps/forum/category/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export class Category extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CategoryAppManager(this, this.props);
  }

  render() {
    const { categoryPage } = this.appManager;
    const threads = this.appManager.threadsConn.arrayApp;

    if (this.appManager.loading) {
      return (
        <MainWrapper marginBottom='90px'>
          <RepoSpinner />
        </MainWrapper>
      );
    }

    if (this.appManager.notFound) {
      return <FourOhFour type='Forum category' />;
    }

    const { title, description, color, pinned } = categoryPage;
    const {
      initiativeManager: { initiative },
      t,
    } = this.props;

    return (
      <div>
        <DocumentHead title={`${initiative.title} Forum - ${title}`} />
        <MainWrapper marginBottom='90px'>
          <Intro
            description={description}
            categoryName={title || 'Untitled Category'}
            categoryColor={`#${color}`}
            buttonHandler={this.appManager.OpenThreadForm}
          />
          {pinned.apps.length ? (
            <CardSection
              title={t('Pinned 📌')}
              subTitle={' '}
              cardApp={pinned}
              CardComponent={ThreadCard}
            />
          ) : (
            <React.Fragment />
          )}
          <CardSection
            title={t('Threads')}
            subTitle={' '}
            cardApp={threads}
            CardComponent={ThreadCard}
            noDataCardType='categoryThreads'
            initiative
          />
        </MainWrapper>
      </div>
    );
  }
}

Category.propTypes = {
  routerStore: PropTypes.object,
  routeName: PropTypes.string,
  params: PropTypes.object,
  initiativeManager: PropTypes.object,
  t: PropTypes.func,
};
